<template>
  <div>
    <v-container class="container--fluid">
      <FarmError />
    </v-container>
  </div>
</template>
<script>
import FarmError from '@/views/components/Notification/FarmError.vue';

export default {
  name: 'GeneralStatsHour',
  components: {
    FarmError,
  },
  data: () => ({
    alarmdata: {},
  }),
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
